module.exports = __webpack_public_path__ + "static/media/SQLite.6fecb595.png";